module.exports = __webpack_public_path__ + "static/media/house-split.51106abb.avif";